import type { GalleryProductBase, ProductManufacture as ManufactureType } from '@/components/ProductCard/types'
import { useCzListSetsContext } from '@/contexts/cz-list-sets/useCzListSetsContext'
import { DistributionCustomsZones } from './DistributionCustomsZones'
import { ManufactureHomologation } from './ManufactureHomologation'
import { ProductDesign } from './ProductDesign'
// import { ProductProduction } from './ProductProduction'
import './product-manufacture.scss'

export function ProductManufacture({
  designCenter,
  manufacture,
  showDesignedIn = true,
  selectedCustomsZones,
  showDistributionCustomsZones = true,
  // showProducedIn = true,
  showHomologatedIn = true,
}: Readonly<{
  designCenter?: GalleryProductBase['design_center']
  manufacture?: ManufactureType
  showDesignedIn?: boolean
  selectedCustomsZones?: string[]
  showDistributionCustomsZones?: boolean
  showProducedIn?: boolean
  showHomologatedIn?: boolean
}>) {
  const {
    // countries_codes_production = [],
    countries_homologation = { ok: [], nok: [], der: [], undefined: [] },
  } = manufacture ?? {}

  const { czListSetsByCustomZone } = useCzListSetsContext()
  const designCenterDetails = designCenter?.id
    ? czListSetsByCustomZone[designCenter.id]
    : undefined

  const countryCode = designCenterDetails?.sales_organization?.substring(0, 2).toUpperCase()

  return (
    <section
      className="product-card-manufacture"
      data-testid="product-card_manufacture"
    >
      {showDesignedIn && (
        <ProductDesign
          designCenter={designCenter}
          countryCode={countryCode}
          designation={designCenterDetails?.designation}
        />
      )}
      {showDistributionCustomsZones && (
        <DistributionCustomsZones selectedCustomsZones={selectedCustomsZones} />
      )}
      {/* {showProducedIn && (
        <ProductProduction countryCodes={countries_codes_production} />
      )} */}
      {showHomologatedIn && (
        <ManufactureHomologation homologatedCountries={countries_homologation} />
      )}
    </section>
  )
}
